import UserProfile from "./components/UserProfile";
import LogoutButton from "./components/LogoutButton";

export default function Header({ user, onLogout, setSelectedSite }) {
    return (
        <header className="app-header">
            <div className="header-right">
                <UserProfile user={user} />
                <LogoutButton onLogout={onLogout} />
            </div>
        </header>
    );
}
